import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 mb-4">
            <i className="ri-sparkling-line text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-medium">焦点深扒</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            焦点深扒
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            编辑团队精选的深度调查报道，每一篇都经过三重核验
          </p>
        </div>

        {/* 全部 5 项一次性可见，无轮播切换 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-background-950/20 to-transparent" />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-bold">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="font-heading text-lg font-bold text-background-50 leading-snug mb-1 line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
              <div className="p-4">
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2 mb-3">
                  {item.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-primary-500"></i>
                    {item.heat}
                  </span>
                  <span>{item.time}</span>
                </div>
              </div>
            </div>
          ))}

          {/* 剩余 2 项横向展示 */}
          {carouselItems.slice(3).map((item, idx) => (
            <div
              key={item.id}
              className={`${idx === 0 ? 'lg:col-span-2' : 'lg:col-span-3'} md:col-span-2 group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:-translate-y-1 cursor-pointer`}
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-60 h-44 sm:h-auto relative overflow-hidden flex-shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex-1 p-5 flex flex-col justify-between">
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-foreground-500 text-sm leading-relaxed line-clamp-3">
                      {item.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-4 text-xs text-foreground-400 mt-3 pt-3 border-t border-background-200">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-primary-500"></i>
                      {item.heat}
                    </span>
                    <span>{item.time}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}